import React from 'react';

import { useAppSelector } from 'src/app/hooks';
import { PlanetControls } from './PlanetControls';
import { Symbol } from './Symbol';
import styles from './PlanetModal.module.css';

import {
  selectCurrentArea,
  selectCurrentPoint,
} from 'src/state';

interface Props {}

export function PlanetModal(props: Props) {
  const currentArea = useAppSelector(selectCurrentArea);
  const currentPoint = useAppSelector(selectCurrentPoint);

  if (!currentArea.fields.symbol) return null;

  const symbolId = currentArea.fields.symbol && currentArea.fields.symbol['en-US'].sys.id;
  const distanceFromTheSun = currentArea.fields.distanceFromTheSun['en-US'];
  const name = currentPoint ?
    currentPoint.fields.name['en-US'] :
    currentArea.fields.name['en-US'];

  return (
    <div className={styles['planet-modal']} >
      <PlanetControls />
      <div className={styles['planet-left-border']} />
      {symbolId && <Symbol symbolId={symbolId} />}
      <div className={styles['planet-text']}>
        <span className={styles['planet-text__distance']}>{distanceFromTheSun} AU</span>
        <span className={styles['planet-text__spacer']}>-</span>
        <span className={styles['planet-text__name']}>{name}</span>
      </div>
      <div className={styles['planet-right-border']} />
    </div>
  );
}
